export default "__VITE_ASSET__CWiuGQyM__"